import { makeStyles } from "@material-ui/core/styles"
const styles = makeStyles({
  dialogPaper: {
    width: "100%",
    padding: "10px",
  },
  select: {
    textAlign: "left",
    "&:after": {
      borderBottom: "1.5px solid black",
      backgroundColor: "#fff",
    },
    // "&.MuiSelect-select:focus": {
    //   backgroundColor: "orange",
    // },
    "&:hover": {
      backgroundColor: "#fff",
    },
  },
  underline: {
    "&::after": {
      // focused
      borderBottom: "1.5px solid black",
    },
  },
})

export default styles
